// External
import React, { useState, useEffect, useContext } from 'react';
import { useSelector, connect } from 'react-redux';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { bool, func, string } from 'prop-types';

// Internal
import { getPendingStatus } from '~APP_UTIL/requestReducer';
import { TableServerSideContext } from '~COMPONENTS/tableServerSide/TableServerSideContext';
import FileInput from '../../../../components/formInputs/FileInput';
import FilesDisplay from '../filesDisplay/FilesDisplay';
import { submitHeaders } from '../actions';
import actionTypes from '../actionTypes';
import Modal from '../../../../modal/Modal';

export const UploadCatalogModal = ({ isOpen, closeModal, classname, submitHeaders }) => {
  const [uploadedFiles, updatedUploadedFiles] = useState([]);
  const [currentFiles, updateCurrentFiles] = useState([]);
  const isSubmitting = useSelector(state => getPendingStatus(state, actionTypes.SUBMIT_CATALOG_HEADERS));

  const { refreshTableData } = useContext(TableServerSideContext);

  const fileInputId = `${classname}Input`;

  useEffect(() => {
    return updatedUploadedFiles([]);
  }, [updatedUploadedFiles]);

  const title = 'Upload Catalog Headers';

  const content = () => {
    return (
      <div className={`${classname}__input`}>
        <FileInput
          id={fileInputId}
          name={fileInputId}
          multiple
          allowDuplicates={false}
          disabled={isSubmitting || uploadedFiles?.length > 0}
          accept='.xlsx,.xml'
          onChange={files => {
            if (Array.isArray(files)) {
              updateCurrentFiles(files);
            }
          }}
          FileSelectLabel='Select Files'
          fileDisplayComponent={props => (
            <FilesDisplay {...props} uploadedFiles={uploadedFiles} isSubmitting={isSubmitting} />
          )}
        />
      </div>
    );
  };

  const footer = () => {
    const submit = async () => {
      const response = await submitHeaders(currentFiles);
      const responseFiles = response.data;
      updatedUploadedFiles(responseFiles);
      refreshTableData();
    };

    return (
      <>
        <ButtonStyled appearance='primary' onClick={closeModal} disabled={uploadedFiles?.length < 1}>
          Done
        </ButtonStyled>
        <ButtonStyled
          className={`${classname}__dialog__upload`}
          appearance='primary'
          onClick={submit}
          disabled={uploadedFiles?.length > 0 || isSubmitting || currentFiles?.length < 1}
        >
          Upload
        </ButtonStyled>
        <ButtonStyled appearance='secondary' onClick={closeModal} data-testid='uploadCatalog-close-icon'>
          Close
        </ButtonStyled>
      </>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={closeModal} />;
};

UploadCatalogModal.propTypes = {
  closeModal: func.isRequired,
  isOpen: bool.isRequired,
  classname: string.isRequired,
  submitHeaders: func.isRequired
};

UploadCatalogModal.defaultProps = {};

export default connect(null, { submitHeaders })(UploadCatalogModal);
